import { render } from "./IconPlay.vue?vue&type=template&id=c48b26d0"
import script from "./IconPlay.vue?vue&type=script&lang=ts"
export * from "./IconPlay.vue?vue&type=script&lang=ts"
script.render = render

export default script